function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint semi: ["error", "never"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
import EmailConfigurationDestroyLink from '@engine/components/containers/email-configurations/destroy-link';
import EmailTemplatesRows from '@engine/components/containers/email-templates/rows';
import { Link } from 'react-router-dom';
import Loader from '@engine/components/presentational/base/loader';
import React from 'react';
import { connect } from 'react-redux';

var EmailConfigurationRows = /*#__PURE__*/function (_React$Component) {
  _inherits(EmailConfigurationRows, _React$Component);

  var _super = _createSuper(EmailConfigurationRows);

  function EmailConfigurationRows(props) {
    var _this;

    _classCallCheck(this, EmailConfigurationRows);

    _this = _super.call(this, props);
    /**
     * Active config - Configuration with visible templates
     */

    _this.state = {
      activeConfigurationId: null
    };
    return _this;
  }

  _createClass(EmailConfigurationRows, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return React.createElement(React.Fragment, null, this.props.isSubmitting ? React.createElement("tr", {
        height: "100px"
      }, React.createElement("td", null, React.createElement(Loader, {
        position: "absolute-center",
        color: "refined-blue"
      }))) : React.createElement(React.Fragment, null, Object.entries(this.props.emailConfigurations).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            _configurationId = _ref2[0],
            configuration = _ref2[1];

        return React.createElement(React.Fragment, {
          key: configuration.configuration_type
        }, React.createElement("tr", null, React.createElement("td", null, configuration.enabled ? React.createElement("span", {
          className: "label label-success"
        }, "Enabled") : React.createElement("span", {
          className: "label label-danger"
        }, "Disabled")), React.createElement("td", null, configuration.name), React.createElement("td", null, I18n.t('feature.emails.configuration_types.' + configuration.configuration_type)), React.createElement("td", null, configuration.recipients && Array.from(configuration.recipients).map(function (recipient, index) {
          return React.createElement("span", {
            key: index
          }, recipient, " ", React.createElement("br", null));
        })), React.createElement("td", null, configuration.emailTemplates && configuration.emailTemplates.length ? React.createElement("a", {
          onClick: function onClick() {
            return _this2.setActiveConfigurationId(configuration.id);
          }
        }, React.createElement("i", null, "with custom templates")) : React.createElement("i", null, "with predefined template")), React.createElement("td", null, React.createElement(Link, {
          to: _this2.props.baseUrl.concat("/".concat(configuration.id, "/edit")),
          className: "edit-configuration-".concat(configuration.id)
        }, I18n.t('actions.default.edit')), React.createElement("span", {
          className: "separator-vertical"
        }), React.createElement(EmailConfigurationDestroyLink, {
          id: configuration.id,
          url: _this2.props.baseUrl.concat("/".concat(configuration.id))
        }))), _this2.isConfigurationIdActive(configuration.id) && React.createElement(EmailTemplatesRows, {
          baseUrl: _this2.props.baseUrl.concat("/".concat(configuration.id)),
          emailTemplateIds: configuration.emailTemplates,
          loadedWithinConfigurations: true,
          configurationType: configuration.configuration_type
        }));
      })));
    }
  }, {
    key: "isConfigurationIdActive",
    value: function isConfigurationIdActive(configurationId) {
      return this.state.activeConfigurationId === configurationId;
    }
  }, {
    key: "setActiveConfigurationId",
    value: function setActiveConfigurationId(configurationId) {
      if (this.isConfigurationIdActive(configurationId)) {
        this.setState({
          activeConfigurationId: null
        });
      } else {
        this.setState({
          activeConfigurationId: configurationId
        });
      }
    }
  }]);

  return EmailConfigurationRows;
}(React.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    emailConfigurations: state.entities.configurations,
    isSubmitting: state.configurationForm.isSubmitting
  };
};

export default connect(mapStateToProps, {})(EmailConfigurationRows);